import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import { api_crud_base, api_crud_route, api_list_route, api_list_order, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    const doc_type = useRef(null);
    
    const type_active = useRef(null);
    const types_actives = useRef(null);
    const dados_actives = useRef(null);

    const [document_state_list, set_document_state_list] = useState([])

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})

    const get_info = async () => {

        let res_1 = await reqGET(`${api_crud_base}/intranet/quality/attribute/type/${getTokenInfo().companycode}/doc_type`)
        set_dados(doc_type.current = res_1.data)

        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined) {

                    let aux_data = res.data.filter(e => parseInt(e.info.settings.document_state) === 4)
                    setData(aux_data)

                    let array_aux = []
                    aux_data.forEach(e => {
                        array_aux = array_aux.filter(e1 => (parseInt(e1) !== parseInt(e.info.settings.doc_type)))
                        array_aux.push(e.info.settings.doc_type)
                    })
                    console.log('array_aux', array_aux)
                    set_dados(types_actives.current = doc_type.current.filter(e => array_aux.includes(e.id)))

                    set_dados(type_active.current = types_actives.current[0].id)
                    let aux = aux_data.filter(e => parseInt(e.info.settings.doc_type) === parseInt(types_actives.current[0].id))
                    set_dados(dados_actives.current = aux)   
                }
            })
            .catch(() => 404
            )
    }


    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            let aux_document_state = [
                {
                    id: 0,
                    label: 'Em vigor'
                },
                {
                    id: 1,
                    label: 'Aguarda aprovação'
                },
                {
                    id: 2,
                    label: 'Em revisão'
                },
                {
                    id: 3,
                    label: 'Aprovado'
                },
                {
                    id: 4,
                    label: 'Obsoleto'
                },
                {
                    id: 5,
                    label: 'Eliminado'
                }
            ]
            set_document_state_list(aux_document_state)

            await get_info()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    const get_type = (id) => {

        if(id !== '') {

            let aux = doc_type.current.filter(e => parseInt(e.id) === parseInt(id))

            return aux[0].info.name
        }
        else {
            return ''
        }

    }

    const change_type = (id) => {

        set_dados(type_active.current = id)
        let aux = data.filter(e => parseInt(e.info.settings.doc_type) === parseInt(id))
        set_dados(dados_actives.current = aux)   

    }

    const columns = [
        {
            id: 'type',
            name: language[lang].field_document_type,
            selector: 'info.settings.doc_type',
            cell: row => (
                row?.info?.settings?.doc_type !== undefined && row?.info?.settings?.doc_type !== '' ? 
                    get_type(row.info.settings.doc_type)
                :   
                    ''
            ),
            width: '15% !important',
            minWidth: '150px !important',
            sortable: true,
            left: true,
        },
        {
            id: 'tag',
            name: language[lang].field_tag,
            selector: 'info.tag',
            width: '8% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            id: 'name',
            name: language[lang].field_name,
            selector: 'info.name',
            width: '24% !important',
            minWidth: '200px !important',
            sortable: true,
            left: true,
        },
        {
            id: 'state',
            name: language[lang].field_state,
            selector: 'info.settings.document_state',
            width: '15% !important',
            minWidth: '150px !important',
            cell: row => (
                parseInt(row.info.settings.document_state) === 3 ?
                    <div className="text-center d-flex align-items-center my-2">
                        {
                            row?.info?.settings?.document_state !== undefined && row.info.settings.document_state !== '' && document_state_list.filter(e => parseInt(e.id) === parseInt(row.info.settings.document_state))?.length > 0 ?
                                document_state_list.map((e_state, k_state) => {
                                    if (parseInt(e_state.id) === parseInt(row.info.settings.document_state)) {
                                        return (
                                            <span key={k_state} className="me-3">{e_state.label}</span>
                                        )
                                    }
                                    else {
                                        return null
                                    }
                                })
                                :
                                document_state_list[0].label
                        }
                        <span className="badge rounded bg-success p-0">
                            <i className="bi bi-check text-white fs-4"></i>
                        </span>
                    </div>
                    :
                    parseInt(row.info.settings.document_state) === 4 ?
                        <div className="text-center my-2">
                            {
                                Array.isArray(document_state_list.filter(e => parseInt(e.id) === parseInt(row.info.settings.document_state))) ?
                                    document_state_list.map((e_state, k_state) => {
                                        if (parseInt(e_state.id) === parseInt(row.info.settings.document_state)) {
                                            return (
                                                <span key={k_state} className="me-3">{e_state.label}</span>
                                            )
                                        }
                                        else {
                                            return null
                                        }
                                    })
                                    :
                                    null
                            }
                            <span className="badge rounded bg-secondary p-0">
                                <i className="bi bi-x text-white fs-4"></i>
                            </span>
                        </div>
                        :
                        parseInt(row.info.settings.document_state) === 5 ?
                            <div className="text-center my-2">
                                {
                                    Array.isArray(document_state_list.filter(e => parseInt(e.id) === parseInt(row.info.settings.document_state))) ?
                                        document_state_list.map((e_state, k_state) => {
                                            if (parseInt(e_state.id) === parseInt(row.info.settings.document_state)) {
                                                return (
                                                    <span key={k_state} className="me-3">{e_state.label}</span>
                                                )
                                            }
                                            else {
                                                return null
                                            }
                                        })
                                        :
                                        null
                                }
                                <span className="badge rounded bg-danger p-0">
                                    <i className="bi bi-x text-white fs-4"></i>
                                </span>
                            </div>
                            :
                            <div className="text-center my-2">
                                {
                                    row.info.settings.document_state !== undefined && row.info.settings.document_state !== '' && Array.isArray(document_state_list.filter(e => parseInt(e.id) === parseInt(row.info.settings.document_state))) ?
                                        document_state_list.map((e_state, k_state) => {
                                            if (parseInt(e_state.id) === parseInt(row.info.settings.document_state)) {
                                                return (
                                                    <span key={k_state} className="me-3">{e_state.label}</span>
                                                )
                                            }
                                            else {
                                                return null
                                            }
                                        })
                                        :
                                        document_state_list[0].label
                                }
                                <span className="badge rounded bg-warning p-0">
                                    <i className="bi bi-arrow-clockwise fs-4"></i>
                                </span>
                            </div>
            ),
            sortable: true,
            center: true,
        },
        {
            id: 'version',
            name: language[lang].field_version,
            selector: 'info.version',
            width: '8% !important',
            minWidth: '100px !important',
            sortable: true,
            center: true,
        },
        {
            id: 'date_1',
            name: language[lang].field_edition_date,
            selector: 'info.info.responsable.edition.date',
            width: '10% !important',
            minWidth: '150px !important',
            cell: row => (
                <span style={{
                    fontFamily: 'monospace',
                    fontVariantNumeric: 'tabular-nums',
                }}>
                    {row?.info?.responsable?.edit?.execution !== undefined ? row.info.responsable.edit.execution.split('T')[0] : ''}
                </span>
            ),
            sortable: true,
            center: true,
        },
        // {
        //     name: language[lang].field_edition_name,
        //     selector: 'info.info.responsable.edition.name',
        //     width: '10% !important',
        //     minWidth: '150px !important',
        //     cell: row => (
        //         row?.info?.responsable?.edit?.name !== undefined ? row.info.responsable.edit.name : ''
        //     ),
        //     sortable: true,
        //     center: true,
        // },
        {
            id: 'date_2',
            name: language[lang].field_aprovation_date,
            selector: 'info.info.responsable.aprovation.date',
            width: '10% !important',
            minWidth: '150px !important',
            cell: row => (
                <span style={{
                    fontFamily: 'monospace',
                    fontVariantNumeric: 'tabular-nums',
                }}>
                    {row?.info?.responsable?.aproval?.execution !== undefined ? row.info.responsable.aproval.execution.split('T')[0] : ''}
                </span>
            ),
            sortable: true,
            center: true,
        },
        // {
        //     name: language[lang].field_aprovation_name,
        //     selector: 'info.info.responsable.aprovation.name',
        //     width: '10% !important',
        //     minWidth: '150px !important',
        //     cell: row => (
        //         row?.info?.responsable?.aproval?.name !== undefined ? row.info.responsable.aproval.name : ''
        //     ),
        //     sortable: true,
        //     center: true,
        // },
        {
            id: 'btn',
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10% !important',
            minWidth: '150px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: { id: row.id }, operation: 'view' } }} replace>
                        <i className="bi bi-eye"></i>
                    </Link>

                    {
                        Array.isArray(row.info.file.pdf) && row.info.file.pdf.length > 0 ?
                            <a className="button button-update button-view p-0 pe-2" href={row.info.file.pdf[row.info.file.pdf.length - 1].link} target='_blank'>
                                <i className="bi bi-eye"></i>
                            </a>
                            :
                            null
                    }

                    {
                        permissions.current.edit ?
                            <Link className="button button-update p-0 ps-2" to={{ pathname: endpoints.regist, state: { item: { id: row.id }, operation: 'edit' } }} style={{ display: '' }} replace>
                                <i className="bi bi-pencil"></i>
                            </Link>
                            :
                            null
                    }

                    {
                        permissions.current.remove ?
                            <button onClick={() => apagar(row['id'])} className="button btn-delete" style={{ display: 'none' }}>
                                <i className="bi bi-trash"></i>
                            </button>
                            :
                            null
                    }
                </span>
        },
    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data: dados_actives?.current !== undefined && dados_actives?.current !== null ? dados_actives.current : [],
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-8">
                                        {permissions.current !== null && (permissions.current.create) && (
                                            <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                                to={{ pathname: endpoints.regist }}
                                                style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                            >
                                                <span>{language[lang].add_new}</span>
                                            </Link>
                                        )}
                                    </div>
                                    <div className="table-body">

                                        <div className="row">
                                            <div className="col-12 mb-3 d-flex">
                                                {
                                                types_actives.current !== undefined && types_actives.current !== null ?
                                                    types_actives.current.map((dt_el, dt_key) => {
                                                        return (
                                                            <div key={dt_key}>
                                                                <button type="button" className={"btn btn-sm btn-outline-secondary rounded-pill me-2" + (parseInt(dt_el.id) === parseInt(type_active.current) ? ' active' : '') } onClick={() => change_type(dt_el.id)} >{dt_el.info.name}</button>
                                                            </div>
                                                        )
                                                    })
                                                :
                                                    null
                                                }
                                            </div>
                                        </div>

                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                defaultSortField="info.tag"
                                                defaultSortAsc={true}
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        </DataTableExtensions>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}